<template>
  <div>
    <div class="banner" v-if="image" :style="'background-image:url(' + image + ');'">

    </div>
    <div class="home-body">
      <div class="container sm-pt-50 xs-pb-50">
        <div class="article" v-if="blogArticle">
          <h1 class="weight500 x-large-text xs-mb-20 md-mb-50">{{blogArticle.title}}</h1>

          <div class="date large-text xs-mb-20 md-mb-50">
            {{blogArticle.created_at_formatted}}
          </div>

          <div class="row">
            <div class="col-xs-12 col-md-9">
              <div class="article-content">
                <div class="content text-justify  large-text" v-html="blogArticle.content">
                </div>
                <div class="xs-mt-50 xs-mb-50 text-center">
                  <router-link :to="{name: 'blog'}" class="btn-pub btn-pub-border-primary xs-full-width">Back To Posts</router-link>
                </div>
                
                <HorizontalAd :containerClass="''"></HorizontalAd>

                <div class="row xs-mt-50" id="comments">
                  <div class="col-xs-12">
                    <BlogCommentsList :comments="blogArticle.comments" :articleId="blogArticle.id"></BlogCommentsList>
                  </div>
                </div>
              </div>
            </div>
            <div class="hidden-sm hidden-xs col-md-3">
              <div class="wrap-blue xs-mb-50 signup-block large-text">
                <span class="weight500">Learn Smarter, Organize Notes, Remember Everything.</span><br /><br />
                Get Started With Us, For Free!<br /><br />
                <router-link :to="{name: 'signup'}" class="btn-pub btn-pub-blank">Sign Up Today</router-link>
              </div>
              <VerticalAd :containerClass="''"></VerticalAd>
              <div class="wrap-black xs-mt-50 signup-block large-text">
                <span class="weight500">Learn Smarter, Organize Notes, Remember Everything.</span><br /><br />
                Get Started With Us, For Free!<br /><br />
                <router-link :to="{name: 'signup'}" class="btn-pub btn-pub-blank">Sign Up Today</router-link>
              </div>
            </div>
          </div>

        </div>
        <div v-else>
          <LoadingIndicator></LoadingIndicator>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
  import _ from 'underscore'
  import { mapState, mapActions, mapGetters } from 'vuex'
  import router from 'src/router'
  import BlogCommentsList from '../blog/BlogCommentsList'
  import HorizontalAd from '../shared/ads/HorizontalAd'
  import VerticalAd from '../shared/ads/VerticalAd'

export default {
    components: {
      BlogCommentsList,
      HorizontalAd,
      VerticalAd
    },
    created() {
      this.$store.dispatch('getBlogPosts');
      this.checkBlogs();
    },
    computed: {
      ...mapState([
      ]),
      ...mapGetters({
        allBlogPosts: 'allBlogPosts',
      }),

      postId() {
        return parseInt(this.$route.params.id);
      },

      blogArticle() {
        if (!this.postId || this.postId <= 0) {
          router.push({ name: 'blog' });
        };
        
        return _.first(_.where(this.allBlogPosts, { id: this.postId }));
      },
      image() {
        if (this.blogArticle && this.blogArticle.blog_images.length > 0) {
          return this.blogArticle.blog_images[0].image_url;
        }
        return null;
      }
    },
    methods: {
      checkBlogs() {
        if (!this.blogArticle) {
          var self = this;
          window.setTimeout(function () { self.checkBlogs() }, 500)
        } else {
          this.$store.commit('SET_PAGE_TITLE', { title: this.blogArticle.meta_title || this.blogArticle.title })
          if (this.blogArticle.meta_desc) {
            this.$store.commit('SET_PAGE_DESCRIPTION', { description: this.blogArticle.meta_desc })
          }
        }
      },
    },
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .home-body {background:#FFFFFF;}

  .banner { width: 100%; height:400px; position: relative; overflow: hidden; background-size: cover; background-repeat: no-repeat; background-position: center center; background-color: #EEEEEE; }

  .article-content {padding-right:60px;}
  .article-text p {}

  .signup-block {padding:50px 20px;}

  @media only screen and (max-width:992px) {
    .banner {height:200px;}
    .article-content {padding:0px;}
  }
</style>



// WEBPACK FOOTER //
// BlogArticlePage.vue?38b64090